import { render, staticRenderFns } from "./TurnjsComponent.vue?vue&type=template&id=44d34499&scoped=true&"
import script from "./TurnjsComponent.vue?vue&type=script&lang=js&"
export * from "./TurnjsComponent.vue?vue&type=script&lang=js&"
import style0 from "./TurnjsComponent.vue?vue&type=style&index=0&id=44d34499&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d34499",
  null
  
)

export default component.exports